import React, { Component } from "react";
import {
  Wrapper,
  Card,
  PrimaryButton,
  Copy,
  Bold,
  Button
} from "app/NativeComponents/common";

import { openUrl } from "app/NativeActions";

import { CheckBoxInput } from "app/NativeComponents/snippets";

class Buttons extends Component {
  renderTerms() {
    if (this.props.accepted_affiliate_latest_terms != 1) {
      return (
        <CheckBoxInput
          onPress={() =>
            this.props.updatePartnerInfo({
              prop: "accepted_terms",
              value: this.props.editPartnerInfo.accepted_terms == 1 ? 0 : 1
            })
          }
          value={this.props.editPartnerInfo.accepted_terms == 1 ? true : false}
          title={""}
          componentView={() => {
            return (
              <Wrapper
                style={{
                  alignItems: "flex-start",
                  justfyContent: "center"
                }}
              >
                <Copy style={{ textAlign: "left" }}>
                  By checking this box, you agree to our
                </Copy>

                <Button
                  onPress={() => {
                    openUrl(
                      "https://dealmachine.com/affiliate-partner-terms-of-service"
                    );
                  }}
                >
                  <Copy
                    style={{
                      textAlign: "left",
                      textDecorationLine: "underline"
                    }}
                  >
                    <Bold>affiliate partner terms of service.</Bold>
                  </Copy>
                </Button>
              </Wrapper>
            );
          }}
        />
      );
    }
  }

  render() {
    return (
      <Wrapper>
        {this.renderTerms()}

        <Card style={{ borderRadius: 30, overflow: "hidden" }}>
          <PrimaryButton
            onPress={() => {
              this.props.savePartnerInfo();
            }}
            formButton
          >
            Save Partner Info
          </PrimaryButton>
        </Card>
      </Wrapper>
    );
  }
}

export default Buttons;
